module.exports = __webpack_public_path__ + "static/media/pastProject_dark.97201ceb.png";